import React, { useEffect } from "react"
import { Modal, ModalHeader, ModalBody } from "reactstrap"
import { useDispatch } from "react-redux"
import UserForm from "./user-form"
import {
    getUserDetailSuccess,
    clearUserDetail,
    clearManageError,
} from "store/users/actions"

const UserModal = ({
    isOpen,
    toggle,
    mode,
    userData,
    onSuccess,
    history,
    currentPage,
    searchKeyword,
}) => {
    const dispatch = useDispatch()

    // Populate user data directly from list when opening modal in edit mode
    useEffect(() => {
        if (isOpen && mode === "edit" && userData) {
            // Directly populate the user data from list instead of making API call
            dispatch(getUserDetailSuccess(userData))
        }
    }, [dispatch, isOpen, mode, userData])

    // Clear data when modal opens or closes
    useEffect(() => {
        if (isOpen) {
            dispatch(clearManageError())
        }
        return () => {
            if (!isOpen) {
                dispatch(clearUserDetail())
                dispatch(clearManageError())
            }
        }
    }, [dispatch, isOpen])

    const handleCancel = () => {
        dispatch(clearUserDetail())
        dispatch(clearManageError())
        toggle()
    }

    const handleSuccess = () => {
        dispatch(clearUserDetail())
        dispatch(clearManageError())
        if (onSuccess) {
            onSuccess()
        }
        toggle()
    }

    const pageTitle = mode === "add" ? "Add User" : "User Details"

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
            <ModalHeader toggle={toggle}>
                <h5 className="modal-title">{pageTitle}</h5>
            </ModalHeader>
            <ModalBody>
                <UserForm
                    page={mode === "add" ? "add" : "detail"}
                    match={{ params: { id: mode === "edit" && userData ? userData.userID : null } }}
                    history={history}
                    onUserCreated={handleSuccess}
                    onSuccess={handleSuccess}
                    onCancel={handleCancel}
                    onTabCompletion={() => {}}
                    isModalMode={true}
                    currentPage={currentPage}
                    searchKeyword={searchKeyword}
                />
            </ModalBody>
        </Modal>
    )
}

export default UserModal
